(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/notifications-marketplace-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/notifications-marketplace-service.js');
"use strict";


const jupiter = svs.core.jupiter;

const getCustomersMarketplaceDataAsync = async () => {
  try {
    const path = '/marketplace/1/notificationsettings';
    const _await$jupiter$callAs = await jupiter.callAsync({
        method: 'GET',
        path,
        data: {}
      }),
      response = _await$jupiter$callAs.response;
    svs.myProfile.logger.debug('communicationSettingsMarketplaceService:getCustomersMarketplaceDataAsync response from jupiter');
    if (response !== null && response !== void 0 && response.error) {
      svs.myProfile.logger.error('getCustomersMarketplaceDataAsync error response from jupiter:', response.error);
      return {
        error: response === null || response === void 0 ? void 0 : response.error,
        notificationSettings: []
      };
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      notificationSettings: (response === null || response === void 0 ? void 0 : response.notificationSettings) || []
    };
  } catch (err) {
    svs.myProfile.logger.error('getCustomersMarketplaceDataAsync error from jupiter:', err);
    return {
      error: err,
      notificationSettings: []
    };
  }
};

const putCustomersMarketplaceDataItemAsync = async notification => {
  try {
    svs.myProfile.logger.debug('putCustomersMarketplaceDataItemAsync notification:', notification);
    const path = '/marketplace/1/notificationsettings';
    const data = {
      notificationSettings: [notification]
    };
    const response = await jupiter.callAsync({
      method: 'PUT',
      path,
      data
    });
    if (response !== null && response !== void 0 && response.error) {
      svs.myProfile.logger.error('putCustomersMarketplaceDataItemAsync error response from jupiter:', response.error);
      return {
        status: 'error',
        error: response.error
      };
    }
    svs.myProfile.logger.debug('putCustomersMarketplaceDataItemAsync response from jupiter');
    return {
      status: 'success'
    };
  } catch (err) {
    svs.myProfile.logger.error('putCustomersMarketplaceDataItemAsync error from jupiter', err);
    return {
      status: 'error',
      error: err
    };
  }
};
const putCustomersMarketplaceDataItemsAsync = async notifications => {
  try {
    svs.myProfile.logger.debug('putCustomersMarketplaceDataItemsAsync notifications:', notifications);
    const path = '/marketplace/1/notificationsettings';
    const data = {
      notificationSettings: notifications
    };
    const response = await jupiter.callAsync({
      method: 'PUT',
      path,
      data
    });
    if (response !== null && response !== void 0 && response.error) {
      svs.myProfile.logger.error('putCustomersMarketplaceDataItemsAsync error response from jupiter:', response.error);
      return {
        status: 'error',
        error: response.error
      };
    }
    svs.myProfile.logger.debug('putCustomersMarketplaceDataItemsAsync response from jupiter');
    return {
      status: 'success'
    };
  } catch (err) {
    svs.myProfile.logger.error('putCustomersMarketplaceDataItemsAsync from jupiter:', err);
    return {
      status: 'error',
      error: err
    };
  }
};
svs.myProfile.react.pages.notifications.notificationsMarketplaceService = {
  getCustomersMarketplaceDataAsync,
  putCustomersMarketplaceDataItemAsync,
  putCustomersMarketplaceDataItemsAsync
};

 })(window);